import ButtonFavourite from './product-like.vue';
import { createApp } from 'vue';

export const productLike = (parent, selector) => {
	const element = parent.querySelector(selector);

	if (!element) return;
	const { id } = parent.dataset;
	const app = createApp(ButtonFavourite, { id });
	app.use(window.app.pinia);
	app.mount(element);
};
